import { render, staticRenderFns } from "./UploadIcon.vue?vue&type=template&id=585b17af"
import script from "./UploadIcon.vue?vue&type=script&lang=js"
export * from "./UploadIcon.vue?vue&type=script&lang=js"
import style0 from "./UploadIcon.vue?vue&type=style&index=0&id=585b17af&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports